import React from 'react';

import { useGetLists } from '@vlabs/api/artemy/client';
import { validate } from '@vlabs/shared';
import { Button } from '@vlabs/uikit/components/controls/button/Button';
import { Input } from '@vlabs/uikit/components/controls/input/Input';
import type { TOption } from '@vlabs/uikit/types';
import type { Control, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControllableValueSelect } from '@vlabs/monokit/shared/ui/value-select';

// ponytail: temporarily disabled files, GUI-3979 — import { AttachmentsInput } from './AttachmentsInput';
import st from './shared.module.sass';
import type { TCreateCardFormData } from '../types.point3';

interface CreateCardFormPoint3Props {
  onSubmit: SubmitHandler<TCreateCardFormData>;
  onCancel: VoidFunction;
  defaultValues?: Partial<TCreateCardFormData>;
}

export function CreateCardFormPoint3({
  onSubmit,
  onCancel,
  defaultValues = undefined,
}: CreateCardFormPoint3Props): React.JSX.Element {
  const { t } = useTranslation();
  const getLists = useGetLists({ page_size: 1000 });
  const listOptions: TOption[] = getLists.data?.lists?.map((list) => ({
    label: list.user_data,
    value: list.list_id,
  })) ?? [];

  const {
    control, handleSubmit, register, formState: { errors },
  } = useForm<TCreateCardFormData>({
    defaultValues: {
      fio: defaultValues?.fio ?? '',
      lists: defaultValues?.lists ?? undefined,
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={st.Page}>
        <div className={st.ModalHeader}>
          <span>{t('features:createCard.title')}</span>
        </div>
        <div className={st.ModalBody}>
          <div className={st.DataContainer}>
            <div>
              <Input
                id="fio"
                label={t('features:createCard.form_fields.fio')}
                {...register('fio', {
                  required: validate.requiredValidator(),
                  maxLength: validate.maxLengthValidator(128),
                })}
                errors={errors}
              />
            </div>
            <div>
              <ControllableValueSelect
                // ControllableValueSelect пока не дженерик, поэтому приводим тип локально.
                control={control as unknown as Control}
                disabled={!!defaultValues?.lists || listOptions.length < 1}
                errors={errors}
                id="lists"
                isClearable
                isMulti
                label={t('features:createCard.form_fields.lists')}
                name="lists"
                options={listOptions}
                rules={{ required: validate.requiredValidator() }}
              />
            </div>
            {/* ponytail: temporarily disabled files, GUI-3979
            <div className={st.AttachmentContainer}>
              <AttachmentsInput
                control={control}
                name="attachments"
              />
            </div>
            */}
          </div>
        </div>
        <div className={st.ModalFooter}>
          <div className={st.ButtonWrapper}>
            <Button
              data-testid="submitCardButton"
              fullWidth
              type="submit"
            >
              {t('features:createCard.btn.create')}
            </Button>
          </div>
          <div className={st.ButtonWrapper}>
            <Button
              data-testid="closeCardButton"
              fullWidth
              kind="secondary"
              onClick={onCancel}
              variant="outlined"
            >
              {t('features:createCard.btn.cancel')}
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
}
